<template>
  <div>
    <AllNav v-if="$route.path.indexOf('/manager') == -1"></AllNav>
    <router-view />
    <div :class="[['home', 'partner'].indexOf($route.name) != -1 ? 'bgF5' : ['about', 'product-1'].indexOf($route.name) != -1 ? 'bgF7F8FD' : '']">
      <div class="text-center text-md-left m-auto pb-4 text-black-50 fs-12" style="max-width: 1180px;">*《国内首创路内泊位智能化无人值守系统上线》</div>
    </div>
    <AllFooter v-if="$route.path.indexOf('/manager') == -1"></AllFooter>
  </div>
</template>

<script>
import AllNav from "@/components/Nav.vue";
import AllFooter from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    AllNav,
    AllFooter,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style>
  @import url(./assets/fonts/font.css);
  .custom-file-input:lang(en)~.custom-file-label::after {
    content: '选择';
  }

  .yahei {
    font-family: 'YaHei';
  }
  .yaheibold {
    font-family: 'YaHei-bold';
  }
  .siyuan {
    font-family: 'SOURCEHANSANSSC-REGULAR';
  }
  .siyuanbold {
    font-family: 'SOURCEHANSANSSC-BOLD';
  }
  .section {
    text-align: center;
    position: relative;
    overflow: hidden;
  }
  .sm-display {
    display: none;
  }
  .sm-hidden {
    display: block;
  }
  .container-padding {
    padding: 50px 0 !important;
  }
  .home-title {
    color: #000000;
    font-size: 37px;
  }
  .home-s-title {
    font-size: 22px;
    color: #9b9b9b;
  }
  .home-s-s-title {
    margin-top: 22px;
    margin-bottom: 60px;
    font-size: 16px;
    color: #9b9b9b;
  }
  .head-bg {
    margin-top: 80px;
  }
  .head-bg .card{
    border: none;
  }
  .card-img {
    border-radius: 0;
    min-height: 240px;
    background: #666;
  }
  .head-bg .card h4{
    font-family: "SOURCEHANSANSSC-BOLD";
    width: 100%;
    text-align: center;
    height: 54px;
    line-height: 54px;
    font-size: 54px;
    font-weight: bold;
    color: #FFFFFF;
    position: absolute;
    left: 0;
    top: calc(50% - 36px);
  }
  .letter-20 {
    letter-spacing: 20px;
  }
  .wd-50 {
    width: 50px;
  }
  .wd-80 {
    width: 80px !important;
  }
  .pt-120 {
    padding-top: 120px;
  }
  .pt-150 {
    padding-top: 150px;
  }
  .pb-60 {
    padding-bottom: 60px;
  }
  .pb-150 {
    padding-bottom: 150px;
  }
  .fs-54 {
    font-size: 54px;
  }
  .fs-48 {
    font-size: 48px;
  }
  .fs-40 {
    font-size: 40px;
  }
  .fs-36 {
    font-size: 36px;
  }
  .fs-30 {
    font-size: 30px;
  }
  .fs-24 {
    font-size: 24px;
  }
  .fs-20 {
    font-size: 20px;
  }
  .fs-18 {
    font-size: 18px;
  }
  .fs-16 {
    font-size: 16px;
  }
  .fs-14 {
    font-size: 14px;
  }
  .fs-13 {
    font-size: 13px;
  }
  .fs-12 {
    font-size: 12px;
  }
  .l-h-48 {
    line-height: 48px;
  }
  .l-h-36 {
    line-height: 36px;
  }
  .l-h-30 {
    line-height: 30px;
  }
  .l-h-28 {
    line-height: 28px;
  }
  .l-h-24 {
    line-height: 24px;
  }
  .l-h-18 {
    line-height: 18px;
  }
  .l-h-16 {
    line-height: 16px;
  }
  .l-h-14 {
    line-height: 14px;
  }
  .pointer {
    cursor: pointer;
  }
  .nowrap {
    white-space: nowrap;
  }
  .v-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top-mask {
    position: relative;
    display: inline-block;
  }
  .top-mask::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 555;
  }
  .c333 {
    color: #333333;
  }
  .c666 {
    color: #666666;
  }
  .c999 {
    color: #999999;
  }
  .cFE {
    color: #fefefe;
  }
  .my-blue {
    color: #275EA3 !important;
  }
  .bgF5 {
    background: #f5f5f5;
  }
  .bgF7F8FD {
    background: #F7F8FD;
  }
  .main-content {
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
  }
  .hover-big-img {
    overflow: hidden;
  }
  .hover-big-img > img {
    transition: all .3s;
    object-fit: cover;
  }
  .hover-big-img > img:hover {
    transform: scale(1.2);
    overflow: hidden;
  }

  .media-line:hover::after {
    width: 100%;
    opacity: 1;
  }
  .media-line::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: rgb(0, 53, 106);
    height: 1px;
    width: 0;
    opacity: 0;
    transition: all 0.6s ease-out;
    -webkit-transition: all 0.6s ease-out;
  }

  /** 按钮样式 */
  .my-btn {
    width: 132px;
    height: 52px;
    border-radius: 10px;
    background: transparent;
  }
  .my-btn:hover {
    background: rgba(0, 0, 0, 0.05);
    color: initial;
  }

  /* 分页样式 */
  .my-pagination {
    position: relative;
  }

  .my-pagination .page-item {
      outline: none;
      box-shadow: none;
      min-height: 30px;
  }

  .my-pagination .page-link {
      background-color: transparent !important;
      border: none;
      color: #999 !important;
      text-align: center;
      outline: none;
      box-shadow: none;
  }

  .my-pagination .active .page-link, .my-pagination .page-link:hover {
      color: #275EA3 !important;
  }

  .my-pagination .page-item:nth-child(2) {
      position: absolute;
      left: 0;
      width: 100px;
      color: #666666 !important;
      background-color: #f6f6f6 !important;
  }

  .my-pagination .page-item:nth-last-child(2) {
      position: absolute;
      right: 0;
      width: 100px;
      color: #666666 !important;
      background-color: #f6f6f6 !important;
  }
  .my-pagination .page-item:not(.disabled):nth-child(2):hover, .my-pagination .page-item:not(.disabled):nth-last-child(2):hover {
      background-color:#5B7EBD !important;
  }
  .my-pagination .page-item:not(.disabled):nth-child(2):hover .page-link, .my-pagination .page-item:not(.disabled):nth-last-child(2):hover .page-link{
      color: #FFFEFE !important;
  }

  /* 弹出框样式 */
  .join-modal .modal-body, .join-modal .modal-header, .apply-modal .modal-body, .apply-modal .modal-header {
    padding: 0;
  }
  .result-dialog {
    max-width: 400px !important;
  }
  .result-dialog .modal-content {
    height: 350px;
  }
  .img-dialog .modal-content {
    background: transparent;
    border: none;
  }

  /** 咨询合作表单样式 */
  .apply-modal .modal-content .top-cont {
    background: #333333;
    background-size: cover;
    height: 80px;
    position: relative;
  }
  .apply-modal .modal-content span.required {
    color: #FF3C00;
    font-weight: 400;
    margin-right: 3px;
  } 
  .apply-modal .modal-content input{  
    border-radius: 2px;
    height: 30px;
    outline: none;
    box-shadow: none;
  }
  .apply-modal .modal-content input.is-invalid {
    border-color: #FF3C00;
  }
  .apply-modal .btn-submit, .result-modal .btn-ok {
    width: 100%;
    height: 40px;
    background: #275EA3;
    border-radius: 4px;
  }
  .apply-modal .btn-submit:hover, .result-modal .btn-ok:hover {
    background: #1e4f8b;
  }
  .apply-modal .btn-submit:active, .result-modal .btn-ok:active {
    background: #1e4f8b;
  }
  .apply-modal .btn-submit.disabled {
    opacity: 0.4;
  }

  @media (min-width: 1600px) {
    .container {
      max-width: 1520px;
    }
    .add-top {
      margin-top: 5vh;
    }
  }
  @media only screen and (max-width:1180px) {
    .head-bg .card h4, .fs-1180-44{
      font-size: 44px;
    }
    .fs-1180-36 {
      font-size: 36px !important;
    }
    .fs-1180-28 {
      font-size: 28px !important;
    }
    .fs-1180-24 {
      font-size: 24px !important;
    }
    .fs-1180-18 {
      font-size: 18px !important;
    }
    .fs-1180-16 {
      font-size: 16px !important;
    }
    .fs-1180-14 {
      font-size: 14px !important;
    }
  }
  @media only screen and (max-width: 800px) {
    .sm-hidden {
      display: none;
    }
    .sm-display {
      display: block;
    }
    .home-title {
      color: #000000;
      font-size: 22px;
      margin-top: 4vh !important;
    }
    .home-s-title {
      font-size: 13px;
      color: #9b9b9b;
    }
    .home-s-s-title {
      margin-top: 10px;
      margin-bottom: 20px;
      font-size: 12px;
      color: #9b9b9b;
    }
    .head-bg .card h4{
      font-size: 36px;
    }
  }

  @media only screen and (max-width: 768px) {
    .fs-768-40 {
      font-size: 40px !important;
    }
    .fs-768-38 {
      font-size: 38px !important;
    }
    .fs-768-36 {
      font-size: 36px !important;
    }
    .fs-768-28 {
      font-size: 28px !important;
    }
    .fs-768-26 {
      font-size: 26px !important;
    }
    .fs-768-24 {
      font-size: 24px !important;
    }
    .fs-768-20 {
      font-size: 20px !important;
    }
    .fs-768-18 {
      font-size: 18px !important;
    }
    .fs-768-16 {
      font-size: 16px !important;
    }
    .fs-768-14 {
      font-size: 14px !important;
    }
    .fs-768-13 {
      font-size: 13px !important;
    }
    .fs-768-12 {
      font-size: 12px !important;
    }
    .my-btn {
      width: 120px !important;
      height: 40px !important;
    }
    .apply-modal .modal-body > div {
      padding: 0 20px !important;
    }
  }

  @media only screen and (max-width: 550px){
    .my-pagination .page-item:nth-child(2), .my-pagination .page-item:nth-last-child(2) {
      width: 70px;
      white-space: nowrap;
    }
    .my-pagination .page-item:nth-child(1), .my-pagination .page-item:nth-last-child(1) {
      width: 0;
      visibility: hidden;
    }
    .xm-plr-10 {
      padding-left: 10px;
      padding-right: 10px;
    }
    .pt-120 {
      padding-top: 80px;
    }
    .pt-150 {
      padding-top: 120px;
    }
    .pb-60 {
      padding-bottom: 40px;
    }
    .pb-150 {
      padding-bottom: 120px;
    }
    .fs-550-24 {
      font-size: 24px !important;
    }
    .fs-550-20 {
      font-size: 20px !important;
    }
    .fs-550-18 {
      font-size: 18px !important;
    }
    .fs-550-16 {
      font-size: 16px !important;
    }
    .fs-550-15 {
      font-size: 15px !important;
    }
    .fs-550-14 {
      font-size: 14px !important;
    }
    .fs-550-13 {
      font-size: 13px !important;
    }
    .fs-550-12 {
      font-size: 12px !important;
    }
    .my-btn {
      width: 90px !important;
      height: 36px !important;
      white-space: nowrap;
    }
  }

  @media only screen and (max-width: 450px) {
    .head-bg, .head-img {
      margin-top: 60px !important;
    }
    .head-bg .card h4 {
      top: calc(50% - 30px);
      font-size: 28px;
    }
    .fs-450-28 {
      font-size: 28px !important;
    }
    .fs-450-14 {
      font-size: 14px !important;
    }
    .fs-450-12 {
      font-size: 12px !important;
    }
  }
</style>
